import env from "@/configuration/env";
import { HubConnectionBuilder, LogLevel, HttpTransportType } from "@microsoft/signalr";
import Vue from "vue";

const connection =
  window.signalrMock ||
  new HubConnectionBuilder()
    .withUrl(`${env.api_base_address}/invoice-hub`, {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
    })
    .configureLogging(process.env.NODE_ENV === "production" ? LogLevel.Error : LogLevel.Information)
    .withAutomaticReconnect()
    .build();
connection.start();

const invoiceHub = new Vue();

connection.on("InvoicePdfCreated", (documentId, groupId) => {
  invoiceHub.$emit("invoice-pdf-created", { documentId, groupId });
});

invoiceHub.joinChargeGroup = (groupId) => {
  return connection.invoke("JoinChargeGroup", groupId);
};
invoiceHub.leaveChargeGroup = (groupId) => {
  return connection.invoke("LeaveChargeGroup", groupId);
};

export default invoiceHub;
